import React from 'react';
import { Field, FieldArray, reduxForm, initialize } from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import moment from 'moment'

import ActionDeleteIcon from 'material-ui/svg-icons/action/delete';
import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import ReplyIcon from 'material-ui/svg-icons/content/reply';
import MenuItem from 'material-ui/MenuItem';

import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';

import FormSelect from '../../../components/FormSelect'
import FormLabel from '../../../components/FormLabel'
import FormCheckBox from '../../../components/FormCheckBox'
import FormAutoComplete2 from '../../../components/FormAutoComplete2'
import FormDatePicker from '../../../components/FormDatePicker'
import FormText from '../../../components/FormText'
import FormSubHolidayContents from '../../../components/FormSubHolidayContents'
import * as commons from '../../../commons';
import * as actions from '../../../actions';
import styles from '../../../styles'

import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';

const validateMonth = (month) => {

  if (!month || !month.length) {
    return []
  }

  let tmpList = []
  const monthErrors = []
  month.forEach((ele, index) => {
    const error = {}
    if (!ele.kind) {
      error.kind = '必須入力'
    }
    if (!ele.date) {
      error.date = '必須入力'
    } else {
      const date = moment(new Date(ele.date)).format('YYYY/MM/DD')

      if (tmpList.indexOf(date) >= 0) {
        error.date = '日付が重複しています'
      } else {
        tmpList.push(date)
      }
    }
    
    monthErrors[index] = error
  })

  return monthErrors

}

const validate = values => {
  const errors = {}

  for (let i = 0; i < 12; i++) {
    let monthErrors = validateMonth(values["month" + (i + 1)])
    if (monthErrors.length) {
      errors["month" + (i + 1)] = monthErrors
    }
  }

  return errors
}

class SystemControllRoumuForm extends React.PureComponent {
  
  constructor(props) {
    super(props)
  }

  render() {

    const { 
      initialValues,
      onSubHolidayClear,
      onDownload,
      handleSubmit,
      error,
      branchOfficeData,
      departmentData,
      selectedBranchOfficeId,
    } = this.props

    const year = initialValues.year || (new Date()).getFullYear()

    return (

      <form onSubmit={() => {}}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

        <div className="row">


          <div className="col-3">

            <Field
                name="branchOfficeId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="支店名"
            >
              {
                branchOfficeData && branchOfficeData.map((x, index) => {
                  return (<MenuItem key={index} value={x.id} primaryText={x.name} />)
                })
              }
            </Field>

          </div>

          <div className="col-3">

            <Field
                name="departmentId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="部署名"
            >

              <MenuItem value={''} primaryText="" />
              {!departmentData ? '' :
                  selectedBranchOfficeId ?
                      departmentData.map((x, index) =>{
                        if (selectedBranchOfficeId == x.branchOfficeId) {
                          return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                        }
                      }) :
                      <MenuItem primaryText="支店を選択" />
              }

            </Field>

          </div>

          <div className="col-4">

            <Field
                name="year"
                component={FormSelect}
                style={{ width: '100%' }}
                label="対象年"
            >

              <MenuItem value={2017} primaryText={'2017 (2016/8 〜 2017/8)'} />
              <MenuItem value={2018} primaryText={'2018 (2018/8 〜 2019/8)'} />
              <MenuItem value={2019} primaryText={'2019 (2018/8 〜 2019/8)'} />
              <MenuItem value={2020} primaryText={'2020 (2019/8 〜 2020/8)'} />
              <MenuItem value={2021} primaryText={'2021 (2020/8 〜 2021/8)'} />
              <MenuItem value={2022} primaryText={'2022 (2021/8 〜 2022/8)'} />
              <MenuItem value={2023} primaryText={'2023 (2022/8 〜 2023/8)'} />
              <MenuItem value={2024} primaryText={'2024 (2023/8 〜 2024/8)'} />
              <MenuItem value={2025} primaryText={'2025 (2024/8 〜 2025/8)'} />
              <MenuItem value={2026} primaryText={'2026 (2025/8 〜 2026/8)'} />
              <MenuItem value={2027} primaryText={'2027 (2026/8 〜 2027/8)'} />

            </Field>

          </div>


          <div className="col-2" style={{paddingTop: 5, display: 'flex', alignItems:'center'}}>
              <div>
                <Field label="退職者含む" name="retireeCheck" component={FormCheckBox} 
                  style={{ ...styles.checkRemember.style, fontSize: 13, width: '130px'}}
                  labelStyle={styles.checkRemember.labelStyle}
                  iconStyle={styles.checkRemember.iconStyle}
                />
              </div>
            </div>

        </div>

          <div className="row" style={{marginTop: 20}}>

            <div className="col-12" style={{textAlign: 'right'}}>

              <FlatButton
                label="ダウンロード"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '160px' , marginRight: '10px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<ArrowDwonloadIcon color={colors.white} />}
                onClick={handleSubmit(onDownload)}
              />

            </div>

          </div>


      </form>
    );
  }
};

SystemControllRoumuForm = reduxForm({
  form: 'systemControllRoumuForm',
  enableReinitialize: true,
  validate,
  onSubmitFail: (errors, dispatch) => {
    dispatch(actions.reducerSnackBar(true, '入力内容に誤りがあります。', colors.red400))
  }
})(SystemControllRoumuForm)

export default SystemControllRoumuForm


// WEBPACK FOOTER //
// ./src/containers/master/systemControll/SystemControllRoumuForm.js